import styled from 'styled-components';

const EvaluationBlock = styled.div`
  * {
    font-size: 14px;
  }

  .w-400p {
    width: 400px;
  }

  .title {
    border-width: 1px;
    border-style: solid;
    flex-grow: 0;
    flex-shrink: 0;
    flex-wrap: wrap;
  }

  .title > .category {
    color: #ffffff;
    flex-grow: 0;
    flex-shrink: 0;
  }

  .title > .title-content {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .rubric-content {
    border: 1px solid #000000;
    border-radius: 1rem;
    padding: 1rem;
  }

  .footer {
    border: 1px solid #5f5f5f;
  }

  .footer-label {
    font-weight: bold;
    background: #d9d9d9;
    color: #5f5f5f;
    flex-grow: 0;
    flex-shrink: 0;
    height: 100%;
  }

  .footer-score {
    color: #5f5f5f;
  }
`;

export default EvaluationBlock;
